/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { TicketEditService } from '../../ticket-edit.service';
import { PlanState } from 'src/app/services/plan-state.service';
import { UntypedFormBuilder } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { TicketEditComponent, setupFormForTask } from '../ticket-edit.component';
import { map } from 'rxjs/operators';
import { EditTicketsCombined } from 'src/app/app-data/models/EditTicketsCombined';
import { ConstraintAcceptanceService } from 'src/app/modules/ticket-edit/constraint-acceptance.service';
import { PlanAccessCheck } from 'src/app/services/PlanAccessCheck';
import { FeatureFlagManager } from 'src/app/services/FeatureFlagManager';
import { ActualPhase } from '@touchplan/common';

@Component({
	selector: 'task-edit',
	templateUrl: './task-edit.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskEditComponent extends TicketEditComponent {
	public ticketLeft$: Observable<number> = new Observable();
	public ticketPosition$: Observable<any> = new Observable();

	private animationOpenTest$: BehaviorSubject<boolean> = new BehaviorSubject(false);

	constructor(
		public planState: PlanState,
		public ticketEditService: TicketEditService,
		protected formBuilder: UntypedFormBuilder,
		protected cd: ChangeDetectorRef,
		protected constraintAcceptanceService: ConstraintAcceptanceService,
		protected planAccessCheck: PlanAccessCheck,
		protected featureFlagManager: FeatureFlagManager
	) {
		super(
			ticketEditService,
			formBuilder,
			planState,
			cd,
			constraintAcceptanceService,
			planAccessCheck,
			featureFlagManager
		);

		setupFormForTask(this.editForm);

		this.ticketPosition$ = this.ticketEditService.combinedEdit$.pipe(
			map((etc: EditTicketsCombined) => {
				return { x: etc.data.left, y: etc.data.top };
			})
		);

		this.animationOpenTest$.next(true);
	}

	get isStarted() {
		return this.data?.data?.actualPhase === ActualPhase.started;
	}
}
